// Research-grade projects data - grouped by intent, not technology

export const projectGroups = [
  {
    id: 'research',
    title: 'Research & Analytical Projects',
    projects: [
      {
        id: 1,
        title: 'StackOverflow Developer Survey Analysis',
        meta: 'Python · Exploratory Analysis · Survey Data',
        description: 'Analyzed large-scale developer survey data to study trends in skills, roles, and technologies using exploratory and statistical analysis.',
        link: 'https://github.com/saayeeem/Data_Analytics_Python/tree/master/Capstone_StackOverflow_Survey',
        linkLabel: 'GitHub'
      },
      {
        id: 2,
        title: 'Bangladesh Cricket Team Win Percentage Analysis',
        meta: 'Python · Statistical Analysis · Time-Series',
        description: 'Conducted longitudinal statistical analysis of match outcomes to examine performance trends and contributing factors.',
        link: 'https://www.kaggle.com/code/saayem/bangladesh-cricket-team-win-analysis',
        linkLabel: 'Kaggle'
      },
      {
        id: 3,
        title: 'Divvy Annual vs Casual Rider Analysis',
        meta: 'R · Behavioral Data Analysis',
        description: 'Compared usage patterns of annual and casual riders to understand behavioral differences through exploratory analysis.',
        link: 'https://www.kaggle.com/code/saayem/divvy-annual-vs-casual-rider',
        linkLabel: 'Kaggle'
      },
      {
        id: 4,
        title: 'House Sales Analysis in King County, USA',
        meta: 'Python · Regression-Oriented Analysis',
        description: 'Investigated housing price determinants through exploratory analysis and regression-oriented reasoning.',
        link: 'https://saayeeem.github.io/Data_Analytics_Python/html_notebooks/Data_Analysis/king-county-house-sales-analysis.html',
        linkLabel: 'Project Page'
      }
    ]
  },
  {
    id: 'analytics',
    title: 'Foundational Data Analytics & Visualization',
    projects: [
      {
        id: 5,
        title: 'US Domestic Flights Performance Dashboard',
        meta: 'Python · Data Visualization',
        description: 'Developed visual dashboards to analyze flight delays and operational patterns in US domestic air traffic.',
        link: 'https://saayeeem.github.io/Data_Analytics_Python/html_notebooks/Visualization/US-Airline-Performance-Analysis-and-Dashboard.html',
        linkLabel: 'GitHub'
      },
      {
        id: 6,
        title: 'Chicago Public Schools Progress Report Analysis',
        meta: 'Python · SQL · Public Datasets',
        description: 'Analyzed academic performance indicators from public education datasets to study institutional trends.',
        link: 'https://github.com/saayeeem/Data_Analytics_Python/blob/master/SQL/Sayem_ChicagoData_Analysis.ipynb',
        linkLabel: 'GitHub'
      },
      {
        id: 7,
        title: 'Tableau Analytics Dashboards',
        meta: 'Tableau',
        description: 'Designed interactive dashboards to communicate insights from real-world datasets.',
        link: 'https://public.tableau.com/app/profile/sayem.chowdhury/vizzes',
        linkLabel: 'Tableau Public'
      }
    ]
  },
  {
    id: 'systems',
    title: 'Systems & Web Development (Earlier Work)',
    projects: [
      {
        id: 8,
        title: 'Car Rental Management System',
        meta: 'PHP',
        description: 'Designed a web-based system for managing rental operations and reservations.',
        link: 'https://github.com/saayeeem/RideHub',
        linkLabel: 'GitHub'
      },
      {
        id: 9,
        title: 'Metro Rail Ticket Booking System',
        meta: 'PHP · Oracle DB · Laravel',
        description: 'Implemented an online ticket booking system for metro rail services.',
        link: 'https://github.com/saayeeem/METRORAIL-TICKET-BOOKING-SYSTEM',
        linkLabel: 'GitHub'
      },
      {
        id: 10,
        title: 'Restaurant Management Application',
        meta: 'React · Firebase',
        description: 'Developed a management application for handling restaurant orders and inventory.',
        link: 'https://confusionserver-cc768.firebaseapp.com/home',
        linkLabel: 'Demo'
      },
      {
        id: 11,
        title: 'Sports Complex Slot Management System',
        meta: 'C# · SQL Server',
        description: 'Built a scheduling system to manage facility bookings.',
        link: 'https://github.com/saayeeem/Sports_Complex_Slot_Management_System',
        linkLabel: 'GitHub'
      }
    ]
  }
];

export const analyticsArchive = {
  title: 'Extended Analytics Archive',
  description: 'A comprehensive collection of exploratory data analysis, machine learning, and NLP projects developed over several years as part of structured learning and independent experimentation.',
  link: 'https://saayeeem.github.io/Data_Analytics_Python/',
  linkLabel: 'View full analytics archive'
};

export const skillsAndMethods = [
  {
    id: 'ml',
    title: 'Machine Learning & AI',
    items: ['Interpretable deep learning', 'Explainable AI (attribution-based methods)', 'Transfer learning', 'Computer vision', 'Natural language processing']
  },
  {
    id: 'programming',
    title: 'Programming & Frameworks',
    items: ['Python', 'PyTorch', 'TensorFlow', 'scikit-learn', 'OpenCV']
  },
  {
    id: 'data',
    title: 'Data & Visualization',
    items: ['Pandas', 'NumPy', 'Matplotlib', 'Seaborn', 'Plotly', 'Tableau']
  },
  {
    id: 'systems',
    title: 'Systems & Tools',
    items: ['SQL', 'PHP', 'C#', 'Git']
  }
];

// Legacy export for backward compatibility
export const projects = projectGroups.flatMap(group =>
  group.projects.map(p => ({
    ...p,
    category: group.title,
    tags: p.meta.split(' · ')
  }))
);
